import { api } from "../../services/NetworkBase";

// ---- Landing summary (existing monolithic endpoint) ----
export async function GetVLPDashboardData(startDate, endDate, selectedUser) {
  try {
    const res = await api
      .get(
        `vlp/dashboard?startDate=${startDate}&endDate=${endDate}&selectedUser=${selectedUser || ""}`
      )
      .json();
    return res;
  } catch (error) {
    throw error;
  }
}

// ---- Modular endpoints used by child components ----
export async function GetOrderStatuses(startDate, endDate, selectedUser) {
  try {
    const res = await api
      .get(
        `vlp/dashboard/orders?startDate=${startDate}&endDate=${endDate}&selectedUser=${selectedUser || ""}`
      )
      .json();
    return res; // StatusDto[]
  } catch (error) {
    throw error;
  }
}

export async function GetAnalystData(startDate, endDate, selectedUser) {
  try {
    const res = await api
      .get(
        `vlp/dashboard/analyst-data?startDate=${startDate}&endDate=${endDate}&selectedUser=${selectedUser || ""}`
      )
      .json();
    return res;
  } catch (error) {
    throw error;
  }
}


export async function GetInvoiceStatuses(startDate, endDate) {
  try {
    const res = await api
      .get(`vlp/dashboard/invoices?startDate=${startDate}&endDate=${endDate}`)
      .json();
    return res; // StatusDto[]
  } catch (error) {
    throw error;
  }
}

export async function GetQuoteStatuses(startDate, endDate) {
  try {
    const res = await api
      .get(`vlp/dashboard/quotes?startDate=${startDate}&endDate=${endDate}`)
      .json();
    return res; // StatusDto[]
  } catch (error) {
    throw error;
  }
}
export async function GetSupplyOrderStatuses(startDate, endDate) {
  try {
    const res = await api
      .get(`vlp/dashboard/supply-orders?startDate=${startDate}&endDate=${endDate}`)
      .json();
    return res; // StatusAmountDto[]
  } catch (error) {
    throw error;
  }
}
export async function GetBottleOrderStatuses(startDate, endDate) {
  try {
    const res = await api
      .get(`vlp/dashboard/bottle-orders?startDate=${startDate}&endDate=${endDate}`)
      .json();
    return res; // StatusDto[]
  } catch (error) {
    throw error;
  }
}

export async function GetEtkQueueStatuses() {
  try {
    const res = await api.get(`vlp/dashboard/etk-queue`).json();
    return res; // StatusDto[]
  } catch (error) {
    throw error;
  }
}
